import ThreeDsIframe from '~/components/payment/deposit/components/three-ds-iframe.js';
import useExecuteDeposit from '~/components/payment/deposit-beta/utils/execute-deposit-hook.js';
import QDExternalPanel from './quick-deposit-external-panel.js';
import { useCloseCurrentContext } from '~/hooks/use-close-context.js';
import { useQDNotifications } from '../utils/use-quick-deposit-hooks.js';
import NativePrompts from '../../deposit-beta/components/native-prompts.js';
import { MAIN_CONTENT, QD_EXECUTE, QD_REDIRECT_URL } from '../utils/constants.js';
import { FETCH_TYPE_ASYNCH } from '../../common/lib/utils/constants.js';

const ExecuteResponseHandler = ({ updateViews, hideView, addView, setResultParams, fullLocation }) => {
	const { formRef, encodedJSON, threeDSMethodURL, updateFormAttr, UrlParams, result } = useExecuteDeposit({
		qdDepositFlow: true
	});

	const { showErrorNotification } = useQDNotifications();
	const closeCurrentContext = useCloseCurrentContext();

	if (result?.error) {
		const { message } = result || {};
		showErrorNotification(message);
		return closeCurrentContext();
	}
	if (result?.successful) {
		const { actualSendHandler } = result;

		if (actualSendHandler === 'EXTERNAL_PANEL') {
			return (
				<QDExternalPanel
					key={actualSendHandler}
					setResultParams={setResultParams}
					onClose={() => {
						updateViews(hideView(QD_EXECUTE));
						updateViews(addView(MAIN_CONTENT));
					}}
				/>
			);
		}

		if (actualSendHandler === 'EXTERNAL_WINDOW') {
			return window.localStorage.setItem(QD_REDIRECT_URL, JSON.stringify(fullLocation));
		}

		if (actualSendHandler === 'NATIVE_APP') {
			const resultParams = {
				accHistRef: result.accHistRef,
				fetch_type: FETCH_TYPE_ASYNCH
			};

			return (
				<NativePrompts
					quickDepositFlow
					key={actualSendHandler}
					methodDetails={result.methodDetails} // use method details from selected method - remove hardcoding
					result={result}
					cancelAppDepositRequest={() => {
						updateViews(hideView(QD_EXECUTE));
						updateViews(addView(MAIN_CONTENT));
					}}
					handleAppDepositRequestSuccess={() => {
						updateViews(hideView(QD_EXECUTE));
						setResultParams(resultParams);
					}}
				/>
			);
		}

		return (
			<>
				{/* {twoFactorAuth && ( // Todo : Might Need this in future.
					<TwoFactorAuth
						onSuccess={handleSuccess}
						onCancel={handleCancel}
						result={result}
						pending={pending}
					/>
				)} */}
				{threeDSMethodURL && (
					<ThreeDsIframe
						key={actualSendHandler}
						threeDSMethodURL={threeDSMethodURL}
						ref={formRef}
						updateFormAttr={updateFormAttr}
						encodedJSON={encodedJSON}
						qdDepositFlow
					/>
				)}
				{UrlParams && setResultParams(UrlParams)}
			</>
		);
	}
};

export default ExecuteResponseHandler;
